import { forwardRef } from "react"
import { Link } from "react-router-dom"
import { adjustPath } from "lib/routes/adjust-path"
import { CaptureNow } from "event-definitions"

// Some callers render a RouterLink purely as a styled button (e.g. Logout) with no `to`.
// react-router 7 throws on click for `to={undefined}`; `{}` keeps v6's "current page" behaviour.
export const RouterLink = forwardRef(function RouterLink({ to, ...props }, ref) {
    return <Link ref={ref} onClickCapture={() => CaptureNow.raise()} to={adjustPath(to) ?? {}} {...props} />
})
